import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { news } from '../mockData';
import { Calendar, ArrowLeft } from 'lucide-react';

const NewsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  
  const newsItem = news.find(item => item.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  if (!newsItem) {
    return (
      <div className="news-detail-page" data-testid="news-detail-error">
        <div className="news-detail-container" style={{ textAlign: 'center', paddingTop: '100px' }}>
          <h1 className="heading-2">Noticia no encontrada</h1>
          <div style={{ marginTop: '24px' }}>
            <button onClick={() => navigate('/noticias')} className="btn-primary">
              Volver a Noticias
            </button>
          </div>
        </div>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', { 
      day: 'numeric',
      month: 'long', 
      year: 'numeric'
    });
  };

  return (
    <div className="news-detail-page" data-testid="news-detail-page">
      <div className="news-detail-container">
        <button 
          onClick={() => navigate('/noticias')} 
          className="news-detail-back"
          data-testid="back-to-news-btn"
        >
          <ArrowLeft size={18} />
          Volver a Noticias
        </button>

        <article>
          <div className="news-detail-header">
            <div className="news-detail-meta">
              <span className="news-detail-category">{newsItem.category}</span>
              <div className="news-detail-date">
                <Calendar size={16} />
                <span>{formatDate(newsItem.date)}</span>
              </div>
            </div>
            <h1 className="news-detail-title">{newsItem.title}</h1>
            <p className="news-detail-summary">{newsItem.summary}</p>
          </div>

          <div className="news-detail-image-container">
            <img
              src={newsItem.image}
              alt={newsItem.title}
              className="news-detail-image"
            />
          </div>

          <div className="news-detail-content">
            {newsItem.content.split('\n\n').map((paragraph, index) => (
              <p key={index}>
                {paragraph}
              </p>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
};

export default NewsDetail;
